export const LOAD_EMENDAS = 'LOAD_EMENDAS'
export const CLEAR_EMENDAS = 'CLEAR_EMENDAS'
export const SET_YEAR = 'SET_YEAR'
export const TOGGLE_LOADING = 'TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/emendas_parlamentares/types.js